$.extend( $.validator.messages, {
    required: "Lütfen bu alanı doldurunuz",
    remote: "Lütfen bu alanı düzeltin.",
    email: "Lütfen geçerli bir eposta adresi yazın",
    url: "Lütfen geçerli bir web adresi (URL) giriniz.",
    date: "Lütfen geçerli bir tarih giriniz.",
    dateISO: "Lütfen geçerli bir tarih giriniz(ISO formatında)",
    number: "Lütfen geçerli bir sayı giriniz.",
    digits: "Lütfen sadece sayısal karakterler giriniz.",
    creditcard: "Lütfen geçerli bir kredi kartı giriniz.",
    equalTo: "Lütfen aynı değeri tekrar giriniz.",
    extension: "Lütfen geçerli uzantıya sahip bir değer giriniz.",
    maxlength: $.validator.format( "Lütfen en fazla {0} karakter uzunluğunda bir değer giriniz." ),
    minlength: $.validator.format( "Lütfen en az {0} karakter uzunluğunda bir değer giriniz." ),
    rangelength: $.validator.format( "Lütfen en az {0} ve en fazla {1} uzunluğunda bir değer giriniz." ),
    range: $.validator.format( "Lütfen {0} ile {1} arasında bir değer giriniz." ),
    max: $.validator.format( "Lütfen {0} değerine eşit ya da daha küçük bir değer giriniz." ),
    min: $.validator.format( "Lütfen {0} değerine eşit ya da daha büyük bir değer giriniz." ),
    require_from_group: $.validator.format( "Lütfen bu alanların en az {0} tanesini doldurunuz." )
} );

$.validator.addMethod("emaildomain",
    function(value, element) {
        return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
    },
    "Lütfen geçerli bir eposta adresi girin"
);

jQuery.validator.addMethod("lettersonly", function(value, element) {
    return this.optional(element) || /[a-zA-ZğüşöçıIİĞÜŞÖÇ\s]+$/i.test(value);
}, "Lütfen sadece harf kullanınız.");